import React, {useEffect, useRef, useState} from 'react';
import {TimelineItem} from './EntryTimeline';

type EntryTimelineItemProps = {
    timelineItem: TimelineItem;
};

export const EntryTimelineItem: React.FunctionComponent<EntryTimelineItemProps> = ({
                                                                                       timelineItem,
                                                                                   }): JSX.Element => {

    const [showDetail, setShowDetail] = useState<boolean>(false);

    return (
        <div id={`gravityflow-note-${timelineItem.id}`}
             className=" clearfix gravityflow-note">
            <div className=" gravityflow-note-avatar">
                {timelineItem.avatar &&
                    <div dangerouslySetInnerHTML={{__html: timelineItem.avatar}}/>}
            </div>
            <div className={'gravityflow-note-body-wrap' + (timelineItem.hasUserComment ? ' alert-light-yellow' : '')}>
                <div className="gravityflow-note-body">
                    <div className="gravityflow-note-header">
                        <div
                            className="gravityflow-note-title">{timelineItem.display_name || 'No Name'}</div>
                        <div
                            className="gravityflow-note-meta">{timelineItem.date_created}</div>
                    </div>
                    {timelineItem?.note_type === 'entry-notification' ?
                        <div className={`gravityflow-note-body ${timelineItem?.detail?.success === 'N' ? 'email-error' : ''}`}>
                            {timelineItem?.detail &&
                                <>
                                    {timelineItem?.detail?.success === 'N' &&
                                        <div className={'text-danger'}><small><strong>Error:</strong> {timelineItem?.detail?.send_result || 'Unknown error sending email'}</small></div>
                                    }
                                    <div><strong>To:</strong> {timelineItem?.detail?.m_to}</div>
                                    <div><strong>Subject:</strong> {timelineItem?.detail?.m_subject}</div>
                                </>
                            }
                            {showDetail &&
                                <div style={{
                                    border: '1px solid #ccc',
                                    width: '100%',
                                    margin: '10px 0 0 0',
                                    padding: '5px',
                                }}>
                                    {typeof timelineItem?.detail?.m_headers === 'object' && Object.keys(timelineItem?.detail?.m_headers).map(h => (
                                        <div>{timelineItem.detail.m_headers[h]}</div>
                                    ))}
                                    <iframe
                                        style={{
                                            width: '100%',
                                            border: 'none',
                                            height: '250px',
                                        }}
                                        srcDoc={timelineItem?.detail?.m_message || ''}
                                    />
                                </div>
                            }
                            <button type="button"
                                    className="btn btn-sm btn-link"
                                    onClick={() => setShowDetail(!showDetail)}
                            >{showDetail ? 'Hide Detail' : 'Show Detail'}</button>
                        </div>
                        :
                        <div className="gravityflow-note-body"
                             dangerouslySetInnerHTML={{__html: timelineItem.value}}/>
                    }
                </div>
            </div>
        </div>
    );
}